/**
 * Спільні константи і утиліти для сторінок support-letters.
 */

export const STATUS_LETTER_OPTIONS = [
	{ value: 'new', label: 'Не переглянуто' },
	{ value: 'viewed', label: 'Переглянуто' },
	{ value: 'in_progress', label: 'В роботі' },
	{ value: 'replied', label: 'Відповідь надіслана' },
	{ value: 'resolved', label: 'Вирішено' },
	{ value: 'closed', label: 'Закрито' },
];

export const STATUS_COLORS = {
	new: 'primary',
	viewed: 'primary',
	in_progress: 'warning',
	replied: 'info',
	resolved: 'success',
	closed: 'secondary',
};

export const STATUS_LABELS = {
	new: 'Не переглянуто',
	viewed: 'Переглянуто',
	in_progress: 'В роботі',
	replied: 'Відповідь надіслана',
	resolved: 'Вирішено',
	closed: 'Закрито',
};

export const SESSION_STATUS_COLORS = {
	open: 'primary',
	waiting: 'warning',
	resolved: 'success',
	closed: 'secondary',
};

export const SESSION_STATUS_LABELS = {
	open: 'Відкрита',
	waiting: 'Очікування відповіді клієнта',
	resolved: 'Вирішено',
	closed: 'Закрита',
};

export const SESSION_STATUS_OPTIONS = [
	{ value: 'open', label: 'Відкрита' },
	{ value: 'waiting', label: 'Очікування відповіді клієнта' },
	{ value: 'resolved', label: 'Вирішено' },
	{ value: 'closed', label: 'Закрита' },
];

export const SENDER_TYPE_COLORS = {
	admin: 'warning',
	user: 'info',
};

export const SENDER_TYPE_LABELS = {
	admin: 'Адмін',
	user: 'Юзер',
};

export const SENDER_TYPE_OPTIONS = [
	{ value: 'user', label: 'Користувач' },
	{ value: 'admin', label: 'Адмін' },
];

export const DEFAULT_CHANNEL_NAME = 'Пошта підтримки КомКом';

/**
 * Форматує дату/час для відображення в таблицях і формах.
 * @param {string|null} val - рядок дати з API (формат Y-m-d H:i:s)
 * @returns {string} відформатована дата або '—'
 */
export const formatDateTime = (val) => {
	if (!val) return '—';
	const d = new Date(val);
	return d.toLocaleString('uk-UA', { dateStyle: 'short', timeStyle: 'short' });
};
